import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { updateCompanyModel } from "#modules/company/infra/updateCompanyModel.api";
import { modelQuery } from "#modules/models/infra/model.query";
import { modelVersionQuery } from "#modules/models/infra/modelVersion.query";
import { processStepCatalogQuery } from "#modules/quoteRequestLines/infra/processStepCatalogQuery";

export const useUpdateCompanyModel = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: updateCompanyModel,
    onSuccess: () => {
      void queryClient.invalidateQueries(modelQuery());
      void queryClient.invalidateQueries(modelVersionQuery());
      void queryClient.invalidateQueries(processStepCatalogQuery());

      showSuccessToast({ title: "Modification enregistrée" });
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
  });

  return { updateCompanyModel: mutate, ...rest };
};
